module.exports = __webpack_public_path__ + "static/media/img.df3a230d.png";